import React from 'react'
import { ImageContainer } from '../elements'

const PostImage = ({ slice }) => {
    const { image, caption } = slice.primary

    return (
        <div>
            <ImageContainer fluid={image.localFile.childImageSharp.fluid} alt={image.alt} />
            {caption && <div className="caption" dangerouslySetInnerHTML={{ __html: caption.html }} />}
        </div>
    )
}

export default PostImage